<div id="map" class="map" [ngStyle]="mapCss"
     leaflet
     [leafletOptions]="options"
     (leafletMapReady)="onMapReady($event)">
</div>

<app-map-layers-control [mapReady]="mapService.mapReady$"
                        (loaded)="mapLayersControlLoaded($event)"
                        [layers]="layers"></app-map-layers-control>
